


import keyMirror from "keymirror";
 export const AnnouncementConstants = {
   ActionTypes: keyMirror({
     // 制度公告
     CHANGEANNOUNCEMENT: null,
	 SELECTANNOUNCEMENT: null,
	 UPDATEANNOUNCEMENT: null,
    
   })
};


// WEBPACK FOOTER //
// ./src/constants/announcement-constants.js